import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { instance } from '../../services/api';
import FormGenerator from '../../generators/FormGenerator';
import { GlobalsContext } from '../../store/Globals';
import { InputType } from '../../store/inputs/types';
import { Container, LoadingContainer } from './styles';

const FormScreen: React.FC<{ asset: { label: string; tag: string } }> = ({
  asset,
}) => {
  const { key } = useParams<{ key: string }>();
  const globals = useContext(GlobalsContext);
  const [inputs, setInputs] = useState([]);
  const [readers, setReaders] = useState([]);
  const [collection, setCollection] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getAssetInputs = async () => {
      const { data } = await instance.post('/api/query/getSchema/', {
        assetType: asset.tag,
      });
      const inpts = data.props;

      setInputs(
        inpts.map((ip: InputType) => ({
          ...ip,
          dataType: globals.dataTypeBase(ip.dataType),
          dropDownValues: globals.getDropDownValues(ip.dataType),
        })),
      );

      if (data.readers && data.readers.length > 0) {
        setReaders(data.readers);
      }

      setCollection(data.collection ? data.collection : asset.tag);

      setLoading(false);
    };
    getAssetInputs();
  }, [asset.tag, globals]);

  if (loading)
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );

  return (
    <Container headerHeight={globals.headerHeight}>
      <FormGenerator
        asset={{ name: asset, inputs }}
        keyId={key}
        readers={readers}
        collection={collection}
      />
    </Container>
  );
};

export default FormScreen;
